import { useDefaultValue } from '@gef-ui/context-defaults';
export const getTraceId = (traceparent)=>traceparent?.split('-')[1];
export const useDefaultComponentValue = ({ inProps, name })=>{
    const props = useDefaultValue({
        inProps,
        slice: 'ErrorReportMaterial',
        components: [
            name
        ]
    });
    return props;
};
